type HomeAorArea = {
  id: string;
  item_id?: string | null;
  name: string;
};

export type HomeAorOption = { label: string; value: string };

/**
 * The area stored on the membership, as the select should show it.
 *
 * Coverage and notifications match `item_id`. A row that still holds the AOR
 * `id` resolves to that same area so the next save stores `item_id`.
 */
export function homeAorSelectValue(
  aors: HomeAorArea[],
  homeAor: string | null
): HomeAorOption | null {
  if (!homeAor) return null;
  const match = aors.find(
    (aor) => aor.id === homeAor || aor.item_id === homeAor
  );
  if (match?.item_id) {
    return { label: match.name, value: match.item_id };
  }
  return { label: homeAor, value: homeAor };
}
